import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "System: Rensa cachen", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Rensa gamla värden (användare, roller och grupper).", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "ms-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.clearCache()), ["prevent"])),
        disabled: _ctx.clearingCache
      }, [
        (!_ctx.clearingCache)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Rensa"))
          : (_openBlock(), _createBlock(_component_fa_icon, {
              key: 1,
              icon: "spinner"
            }))
      ], 8, _hoisted_6),
      (_ctx.clearCacheStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.clearCacheStatus), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}